import React, { useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import ErrorPage from '@rsos/components/capstone/ErrorPage';
import { AppIaRWrapper } from '@rsos/components/capstone/Layout/AdminLayout/AdminLayout.styles';
import AppLoading from '@rsos/components/capstone/Layout/AppLoading';
import Main from './Main';
import { initialize } from './appSlice';
import { persistor } from './store';

const useInitialize = dispatch => {
  useEffect(() => {
    (async () => {
      const action = await dispatch(initialize());
      if (action && action.error) {
        throw new Error(action.error);
      }
    })();
  }, []);
};

const App = () => {
  const dispatch = useDispatch();
  const { initialized, initializing, initError } = useSelector(
    state => state.responders,
  );
  useInitialize(dispatch);

  return useMemo(() => {
    if (initError) {
      return <ErrorPage persistor={persistor} />;
    }

    if (initializing) {
      return <AppLoading />;
    }

    if (initialized) {
      return (
        <AppIaRWrapper>
          <Main />
        </AppIaRWrapper>
      );
    }

    return <ErrorPage persistor={persistor} />;
  }, [initialized, initializing, initError]);
};

export default App;
